import { getJsonResponse } from "../@api/jsonResponse";
import type { Copy } from "../copy";

export interface LangResponse {
  fi: Copy;
  sv: Copy;
  en: Copy;
}

export const langJsonGet = (): Promise<LangResponse> =>
  fetch("/lang.json", {
    method: "GET",
  }).then(getJsonResponse);
